export const GENERAL_TABS = [
  {
    id: 'legal-acts',
    title: 'tabs.legalActs.title',
    content: {
      title: 'tabs.legalActs.content.title',
      links: [
        {
          id: '1',
          title: 'tabs.legalActs.content.links.doc1',
          url: 'http://www.arlis.am/DocumentView.aspx?DocID=110855'
        },
        {
          id: '2',
          title: 'tabs.legalActs.content.links.doc2',
          url: 'https://www.arlis.am/hy/acts/74503'
        },
        {
          id: '3',
          title: 'tabs.legalActs.content.links.doc3',
          url: 'https://www.arlis.am/hy/acts/127480'
        },
        {
          id: '4',
          title: 'tabs.legalActs.content.links.doc4',
          url: 'https://www.arlis.am/hy/acts/72714'
        },
        {
          id: '5',
          title: 'tabs.legalActs.content.links.doc5',
          url: 'https://www.arlis.am/hy/acts/75096'
        },
        {
          id: '6',
          title: 'tabs.legalActs.content.links.doc6',
          url: 'https://www.arlis.am/hy/acts/77936'
        },
        {
          id: '7',
          title: 'tabs.legalActs.content.links.doc7',
          url: 'https://www.arlis.am/hy/acts/65586'
        },
        {
          id: '8',
          title: 'tabs.legalActs.content.links.doc8',
          url: 'https://www.arlis.am/hy/acts/152392'
        },
        {
          id: '9',
          title: 'tabs.legalActs.content.links.doc9',
          url: 'https://www.arlis.am/hy/acts/93223'
        },
        {
          id: '10',
          title: 'tabs.legalActs.content.links.doc10',
          url: 'https://www.arlis.am/DocumentView.aspx?DocID=373'
        },
        {
          id: '11',
          title: 'tabs.legalActs.content.links.doc11',
          url: 'https://www.arlis.am/documentview.aspx?docID=93142'
        },
        {
          id: '12',
          title: 'tabs.legalActs.content.links.doc12',
          url: 'https://www.arlis.am/documentview.aspx?docid=74658'
        }
      ]
    }
  },
  {
    id: 'shareholders',
    title: 'tabs.shareholders.title',
    content: {
      title: 'tabs.shareholders.content.title',
      text: 'tabs.shareholders.content.text'
    }
  },
  {
    id: 'reports',
    title: 'tabs.reports.title',
    content: {
      title: 'tabs.reports.content.title',
      links: [
        {
          id: '1',
          title: 'tabs.reports.content.links.report2021',
          url: '/docs/reports/fsr_2021.pdf'
        },
        {
          id: '2',
          title: 'tabs.reports.content.links.report2022',
          url: '/docs/reports/fsr_2022.pdf'
        },
        {
          id: '3',
          title: 'tabs.reports.content.links.report2023',
          url: '/docs/reports/fsr_2023.pdf'
        },
        {
          id: '4',
          title: 'tabs.reports.content.links.report2024',
          url: '/docs/reports/fsr_2024.pdf'
        },
        {
          id: '5',
          title: 'tabs.reports.content.links.report2025',
          url: '/docs/reports/fsr_2025.pdf'
        }
      ]
    }
  },
  {
    id: 'documents',
    title: 'tabs.documents.title',
    content: {
      title: 'tabs.documents.content.title',
      links: [
        {
          id: '1',
          title: 'tabs.documents.content.links.license',
          url: '/docs/license.pdf'
        },
        {
          id: '2',
          title: 'tabs.documents.content.links.charter',
          url: '/docs/charter-v2.pdf'
        },
        {
          id: '3',
          title: 'tabs.documents.content.links.termsAndConditions',
          url: {
            hy: '/docs/terms/hy/terms.pdf',
            ru: '/docs/terms/ru/terms.pdf',
            en: '/docs/terms/en/terms.pdf'
          }
        },
        {
          id: '4',
          title: 'tabs.documents.content.links.privacyPolicy',
          url: {
            hy: '/docs/privacy-policy/hy/privacy-policy.pdf',
            ru: '/docs/privacy-policy/ru/privacy-policy.pdf',
            en: '/docs/privacy-policy/en/privacy-policy.pdf'
          }
        },
        // {
        //   id: '5',
        //   title: 'tabs.documents.content.links.structure',
        //   url: '/docs/Թիմ_Փեյ_ՓԲԸ_կազմակերպչական_կառուցվածք.pdf'
        // },
        {
          id: '6',
          title: 'tabs.documents.content.links.digitalCardAgreement',
          url: '/docs/digital-card-agreement.pdf'
        }
      ]
    }
  },
  {
    id: 'complaints',
    title: 'tabs.complaints.title',
    content: {
      title: 'tabs.complaints.title',
      links: [
        {
          id: '1',
          title: 'tabs.complaints.content.links.guide',
          url: '/docs/complaint/Ինչ_անել_եթե_բողոք_ունեք.pdf'
        },
        {
          id: '2',
          title: 'tabs.complaints.content.links.conflictResolution',
          url: '/docs/complaint/Վեճերի_լուծման_բացատրական_ամփոփագիր.doc'
        },
        {
          id: '3',
          title: 'tabs.complaints.content.links.complaintProcess',
          url: '/docs/complaint/Բողոք_պահանջի_քննության_գործընթաց.doc'
        },
        {
          id: '4',
          title: 'tabs.complaints.content.links.applicationForm',
          url: '/docs/complaint/Ներկայացման ձև.pdf'
        },
        {
          id: '5',
          title: 'tabs.complaints.content.links.receipt',
          url: '/docs/complaint/Ստացական.pdf'
        }
      ]
    }
  }
]
